import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            全部分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            八大内容分类，覆盖热门影视、综艺动漫、纪录体育等全领域
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-4">
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <span className="text-xs text-foreground-400">
                {cat.count.toLocaleString()} 部资源
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}